import $ from 'jquery';

$(document).popover({
  selector: '[data-toggle="popover"]',
});

$(document).tooltip({
  selector: '[data-toggle="tooltip"]',
});
